<template>
  <div class="box">
    <div class="floor1 clearfix">
      <div class="left_box">
        <img src="../../assets/img/introduction/logo.svg" alt="" />
        <div class="title">Why use Kinvest?</div>
      </div>
      <img src="../../assets/img/introduction/fill.svg" class="bg" alt="" />
    </div>
    <div class="floor2">
      <div class="title1 title_line">Group saving with higher interest</div>
      <div class="title2">Save together, achieve more!</div>
      <div class="list_box" v-for="item in list" :key="item.key">
        <img :src="item.img" alt="" />
        <div class="txt_box">
          <div class="title">{{ item.title }}</div>
          <div class="txt">{{ item.txt }}</div>
        </div>
      </div>
    </div>
    <div class="floor3">
      <div class="title1 title_line">Group loan with higher amount</div>
      <div class="f3_box">
        <div class="list list_r_line">
          <div class="txt1">30,000<span>KSh</span></div>
          <div class="txt2">Maximum loan</div>
        </div>
        <div class="list">
          <div class="txt1">78%<span>APR</span></div>
          <div class="txt2">Lowest interest</div>
        </div>
      </div>
      <div class="content">
        We provide quick loan from Ksh 2,000 to Ksh 30,000 and the repayment
        period range up to 180 days. The interest of kinvest is lowest among all
        the loan apps in your phone, which is from 1.5% per week,APR is 78%.
        <br />Anytime and anywhere,you could get the quick loan service from
        KINVEST, all around the clock, from Monday to Sunday.
      </div>
    </div>
    <div class="floor4">
      <div class="title1 title_line">Free & Transpareent</div>
      <div class="list_box">
        <div class="list">
          <img src="../../assets/img/introduction/downloan.svg" alt="" />
          <div class="txt">
            Download and use the app for free
          </div>
        </div>
        <div class="list">
          <img src="../../assets/img/introduction/charges.svg" alt="" />
          <div class="txt">
            Transparent charges
          </div>
        </div>
      </div>
    </div>
    <div class="floor5">
      <div class="title1 title_line">Safe & Secure</div>
      <div class="txt">
        Your information is securely stored in our servers. We also ensure your
        information is only visible to authorized users.
      </div>
    </div>
    <div class="floor5">
      <div class="title1 title_line">Accurate & Reliable</div>
      <div class="txt">
        Our platform has an uptime of 99.99%, your data can be accessed anytime.
        We also guarantee you 100% accuracy on all reports.
      </div>
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasToken: false,
    };
  },
  computed: {
    list: () => {
      const img1 = require("../../assets/img/introduction/group.svg");
      const img2 = require("../../assets/img/introduction/invite.svg");
      const img3 = require("../../assets/img/introduction/saving.svg");
      const img4 = require("../../assets/img/introduction/rate.svg");
      const img5 = require("../../assets/img/introduction/Withdraw.svg");
      return [
        {
          img: img1,
          title: "Create group",
          txt: "Quick and easy create your group",
          key: "a",
        },
        {
          img: img2,
          title: "Invite your friends",
          txt: "Invite friends to join your group, improve the group level",
          key: "b",
        },
        {
          img: img3,
          title: "Saving money",
          txt:
            "Get higher deposit interest rate when have more savings and friends",
          key: "c",
        },
        {
          img: img4,
          title: "Get up to 5% interest rate",
          txt:
            "Save together with your friends now to get a better interest rate. ",
          key: "d",
        },
        {
          img: img5,
          title: " Easy and convince deposit and Withdraw",
          txt: "Quick and easy create your group",
          key: "e",
        },
      ];
    },
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.title_line {
  position: relative;
  &::before {
    content: " ";
    width: 38px;
    height: 10px;
    position: absolute;
    background: linear-gradient(270deg, #9afcff 0%, #85fbff 100%);
    left: 16px;
    top: 12px;
    z-index: -1;
  }
}

.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f7fbff;
  padding-top: 110px;
  padding-bottom: 18px;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(180deg, #228cff 0%, rgba(19, 163, 255, 0) 100%);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .bg {
      width: 135px;
      height: 149px;
      padding-top: 6px;
      float: right;
    }
    .left_box {
      float: left;
      padding: 32px 0 0 22px;
      img {
        display: block;
        width: 79px;
        height: 14px;
      }
      .title {
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #ffffff;
        line-height: 28px;
        margin-top: 12px;
      }
    }
  }
  .floor2 {
    margin: 0 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 20;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
      margin-bottom: 6px;
    }
    .title2 {
      padding: 0 16px;
      font-size: 14px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 19px;
      margin-bottom: 24px;
    }
    .list_box {
      padding: 0 24px;
      margin-top: 20px;
      img {
        width: 32px;
        height: 32px;
        display: inline-block;
        vertical-align: top;
      }
      .txt_box {
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 48px);
        margin-left: 16px;
        .title {
          font-size: 14px;
          font-family: "rm";
          font-weight: 500;
          color: #303f49;
          line-height: 16px;
          margin-bottom: 6px;
        }
        .txt {
          font-size: 12px;
          font-family: "rr";
          font-weight: 400;
          color: #50616c;
          line-height: 16px;
        }
      }
    }
  }
  .floor3 {
    margin: 0 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 20;
    margin-top: 16px;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
    }
    .f3_box {
      width: 100%;
      padding: 26px 0 24px;
      .list {
        width: 50%;
        text-align: center;
        display: inline-block;
        vertical-align: top;
        &.list_r_line {
          position: relative;
          &::before {
            content: " ";
            width: 1px;
            height: 30px;
            background: #e9eff5;
            position: absolute;
            right: 0;
            top: 9px;
          }
        }
        .txt1 {
          height: 28px;
          font-size: 24px;
          font-family: "rb";
          font-weight: bold;
          color: #fb560a;
          line-height: 28px;
          span {
            display: inline-block;
            vertical-align: top;
            height: 16px;
            font-size: 14px;
            font-family: "rr";
            font-weight: 400;
            color: #979fa4;
            line-height: 19px;
            padding: 10px 0 0 2px;
          }
        }
        .txt2 {
          font-size: 12px;
          text-align: center;
          font-family: "rr";
          font-weight: 400;
          color: #50616c;
          line-height: 16px;
          margin-top: 6px;
        }
      }
    }
    .content {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      padding: 0 16px;
    }
  }
  .floor4 {
    margin: 0 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 20;
    margin-top: 16px;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
    }
    .list_box {
      padding: 24px 16px 0;
      display: flex;
      justify-content: space-between;
      .list {
        width: calc(50% - 5px);
        padding: 16px 10px;
        box-sizing: border-box;
        background: #f7fbff;
        border-radius: 2px;
        img {
          display: block;
          width: 40px;
          margin: 0 auto 4px;
        }
        .txt {
          height: 42px;
          font-size: 12px;
          font-family: "rr";
          font-weight: 400;
          color: #50616c;
          line-height: 21px;
          text-align: center;
        }
      }
    }
  }
  .floor5 {
    margin: 0 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 20;
    margin-top: 16px;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
    }
    .txt {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      margin-top: 24px;
      padding: 0 16px;
    }
  }
}
</style>
